import browerOpen from './brower-open.vue';

let Plugin = {},
  vueClass = Vue.extend(browerOpen),
  vueInstance;

Plugin.install = function(Vue, opt) {
  opt.root.browerOpen = function() {
    // if (!vueInstance) {
    let el = document.createElement('div');
    document.querySelector('body').appendChild(el);

    vueInstance = new vueClass({
      el: el,
      router: opt.router,
    });
    // }

    return vueInstance.show(...arguments);
  };
};

export default Plugin;
